<template>
  <app-popup :active.sync="isActive" title="Информация о льготе" class="employee-privilege-popup">
    <template v-if="status === STATUSES.loaded">
      <charge-privilege-block v-for="(priviligeInfo, index) in info" :key="index" :info="priviligeInfo"/>
    </template>
    <template v-else-if="status === STATUSES.loading">
      <div class="employee-privilege-popup__loading">
        <div class="block-loading"/>
        <div class="employee-privilege-popup__loading-text">Получаю информацию о льготе</div>
      </div>
    </template>
    <template v-else-if="status === STATUSES.error">
      <div class="employee-privilege-popup__error">
        <div class="employee-privilege-popup__error-icon">
          <app-icon name="XIcon" size="40px"/>
        </div>
        <div class="employee-privilege-popup__error-text">
          Не удалось получить информацию
        </div>
      </div>
    </template>

  </app-popup>
</template>

<script>
  import ChargePrivilegeBlock from "@/components/calculated-program/privileges/ChargePrivilegeBlock";

  const STATUSES = {
    loading: 0,
    loaded: 1,
    error: 2,
  };

  export default {
    name: "ChargePrivilegePopup",
    components: {
      ChargePrivilegeBlock
    },
    props: {
      buildingsId: {}
    },
    data(){
      return {
        STATUSES: STATUSES,
        status: STATUSES.loading,
        isActive: false,
        info: [],
      }
    },
    computed: {},
    methods: {
      open(id){
        if(!id) return false;
        this.isActive = true;
        this.getInfo(id);
      },
      async getInfo(id){
        this.status = STATUSES.loading;
        try{
          let params = {
            priv_charge_id: id,
            buildings_id: this.buildingsId,
          };
          let {data} = await this.$http.get('privilege_calculations', {
            params: params
          });
          this.info = data;
          this.status = STATUSES.loaded;
        }
        catch (e) {
          this.status = STATUSES.error;
        }
      }
    }
  }
</script>

<style lang="scss">
  .employee-privilege-popup{
    &__loading, &__error{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .block-loading{
        &::before{
          width: 30px;
          height: 30px;
        }
      }

      &-text{
        text-align: center;
        line-height: 1.1;
        margin-top: 10px;
        font-weight: 500;
      }
    }

    &__error{
      color: rgba(var(--app-danger), 1);

      &-icon{
        display: flex;
        align-items: center;
        justify-content: center;

      }
    }
  }
</style>
